import React, { FC, useEffect } from 'react'

import { useDispatch } from 'react-redux'

import { preparePromoRatingAction } from 'actions/rating/promoNextAction'
import { setRatingFetchMoreAction } from 'actions/rating/setRatingFetchMoreAction'
import { NotFound } from 'components/block/Notice/NotFound/NotFound'
import { DefaultLoader } from 'components/presentational/AnimatedWatch/AnimatedWatch'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

import { GQLRatingQuery } from './gql/__generated__/Rating'
import { LIMIT_PHOTOS, MINIMUM_PHOTOS_TAIL_COUNT } from './Rating.constants'
import { RatingQueue } from './RatingQueue'

export const RatingPhotosUpdate: FC<{
  fetchMore: Function
  ui: GQLRatingQuery['ui']
}> = ({ fetchMore, ui }) => {
  const dispatch = useDispatch()

  const { currentQueuePhotos, loading, votedCounter, hasNextPage } =
    useShallowEqualSelector(
      ({
        photoRatingNext: {
          currentQueuePhotos,
          votedCounter,
          loading,
          hasNextPage,
        },
      }) => ({
        currentQueuePhotos,
        loading,
        votedCounter,
        hasNextPage,
      })
    )

  useEffect(() => {
    if (votedCounter !== 0 && votedCounter % LIMIT_PHOTOS === 0) {
      dispatch(preparePromoRatingAction(true))
    }
  }, [dispatch, votedCounter])

  useEffect(() => {
    if (
      currentQueuePhotos.length !== 0 &&
      currentQueuePhotos.length <= MINIMUM_PHOTOS_TAIL_COUNT &&
      !loading &&
      hasNextPage
    ) {
      dispatch(setRatingFetchMoreAction())
      fetchMore()
    }
  }, [dispatch, currentQueuePhotos, fetchMore, loading, hasNextPage])

  if (currentQueuePhotos.length === 0 && !loading) {
    return <NotFound />
  }

  if (currentQueuePhotos.length > 0) {
    return <RatingQueue ui={ui} />
  }

  return <DefaultLoader />
}
